import React from 'react';
import * as lodash from 'lodash';
import {Button, Checkbox, message} from 'antd';
import {WeaDialog, WeaSearchGroup, WeaFormItem, WeaInput, WeaSelect, WeaBrowser,WeaCheckbox} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EField_New from './base/EField_New'

// 我的协作，数据来源
class Content_13_DataSource extends React.Component {
    state = {
        id: this.props.tabData.id,
        title: this.props.tabData.title || '',
        cooperationSource: this.props.tabData.cooperationSource,
        cooperationModule: this.props.tabData.cooperationModule,
        viewType: this.props.tabData.viewType,
        cooperationState: this.props.tabData.cooperationState,
        eFieldNewDataSource: this.props.tabData.eFieldNewDataSource || this.props.tabNew.eFieldNewDataSource,
        eFieldNewUsedKeys: this.props.tabData.eFieldNewUsedKeys || [],
        eFieldNewVisible: false,
    };

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    render() {
        const{ title,cooperationSource,cooperationModule,viewType,cooperationState,id, eFieldNewDataSource, eFieldNewUsedKeys, eFieldNewVisible } = this.state;
        const {tabNew} = this.props;
        let EFieldNew = <div></div>;
        if (eFieldNewVisible) {
            const eFieldNewProps = {
                eFieldNewDataSource: _.cloneDeep(eFieldNewDataSource),
                eFieldNewUsedKeys: _.cloneDeep(eFieldNewUsedKeys),
                onOk: (data) => {
                    this.setState({
                        eFieldNewDataSource: _.cloneDeep(data.eFieldNewDataSource),
                        eFieldNewUsedKeys: _.cloneDeep(data.eFieldNewUsedKeys),
                        eFieldNewVisible: false
                    });
                },
                onCancel: () => {
                    this.setState({
                        eFieldNewVisible: false
                    });
                }
            };
            EFieldNew = <EField_New {...eFieldNewProps}/>
        }
        const eFieldNewUsedNames = [];
        for (let i = 0; i < eFieldNewUsedKeys.length; i++) {
            for (let j = 0 ; j < eFieldNewDataSource.length; j++) {
                if (eFieldNewUsedKeys[i] == eFieldNewDataSource[j].key) {
                    eFieldNewUsedNames.push(eFieldNewDataSource[j].name);
                }
            }
        }
        return (
            <WeaDialog
                className="portal-esetting-dialog"
                visible={true}
                title={getLabel(19480, '内容设置')}
                icon="icon-coms-portal"
                iconBgcolor='#1a57a0'
                style={{width: 660, height: 507}}
                hasScroll={true}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
            >
                <WeaSearchGroup title={getLabel(33396, '设置项')} needTigger={true} showGroup={true}>
                    <WeaFormItem label={getLabel(24986, '标题')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaInput inputType="multilang" isBase64={true} value={title} viewAttr={3} onChange={value => this.setState({title: value})}/>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(386559, '协作来源')} labelCol={{span: 6}} wrapperCol={{span: 16}} >
                        <div style={{display: 'inline-block'}}>
                            <div style={{width: '100px'}}>
                                <WeaSelect
                                    options={
                                        tabNew.cooperationSource.options.map((item) => {
                                            return {key: item.key, selected: false, showname: item.value};
                                        })
                                    }
                                    value={cooperationSource||tabNew.cooperationSource.selected}
                                    onChange={value => {
                                        this.setState({cooperationSource: value});
                                    }}
                                />
                            </div>
                        </div>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(83265, '协作板块')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <div style={{width: '100px'}}>
                            <WeaSelect
                                options={
                                    tabNew.cooperationModule.options.map((item) => {
                                        return {key: item.key, selected: false, showname: item.value};
                                    })
                                }
                                value={cooperationModule||tabNew.cooperationModule.selected}
                                onChange={value => {
                                    this.setState({cooperationModule: value});
                                }}
                            />
                        </div>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(17483, '查看类型')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <div style={{width: '100px'}}>
                            <WeaSelect
                                options={
                                    tabNew.viewType.options.map((item) => {
                                        return {key: item.key, selected: false, showname: item.value};
                                    })
                                }
                                value={viewType||tabNew.viewType.selected}
                                onChange={value => {
                                    this.setState({viewType: value});
                                }}
                            />
                        </div>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(386560, '协作状态')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <div style={{width: '100px'}}>
                                    <WeaSelect
                                    options={
                                        tabNew.cooperationState.options.map((item) => {
                                            return {key: item.key, selected: false, showname: item.value};
                                        })
                                    }
                                    value={cooperationState||tabNew.cooperationState.selected}
                                    onChange={value => {
                                        this.setState({cooperationState: value});
                                    }}
                                />
                            </div>
                    </WeaFormItem>
                     <WeaFormItem label={getLabel(19495, '显示字段')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        {EFieldNew}
                        <div style={{height: '30px', lineHeight: '23px'}}>
                            <i className="icon-coms-Flow-setting portal-esetting-btn" onClick={() => this.setState({eFieldNewVisible: true})}/>
                            <span>{eFieldNewUsedNames.join('，')}</span>
                        </div>
                    </WeaFormItem>
                </WeaSearchGroup>
            </WeaDialog>
        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }
    onOk() {
        if (!this.state.title) {
            message.warning(getLabel(15859, '必要信息不完整！'));
        } else {
            this.props.onOk(this.state);
        }
    }
    onCancel() {
        this.props.onCancel();
    }
}

export default Content_13_DataSource;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_13_DataSource.js